$(function () {
  // Elemento da publicidade
  const $pubAppend = $('.pub-append');
  // Elemento que segura o texto da notícia
  const $textoNoticia = $('.texto-noticia');
  if ($pubAppend.length > 0) {
    // Grava o html da notícia
    let htmlNoticia = $textoNoticia.html();
    // Regra de busca
    let regexNoticia = new RegExp('{{PUBLICIDADE}}');
    // Verifica se no texto contém o parâmetro
    if (regexNoticia.test(htmlNoticia)) {
      // Substitui o parâmetro por uma div para segurar a publicidade
      htmlNoticia = htmlNoticia.replace(
        '{{PUBLICIDADE}}',
        '<div class="texto-noticia-pub"></div>',
      );
      // Atualiza o texto a notícia com o novo elemento
      $textoNoticia.html(htmlNoticia);
      // Adicionar o elemento da publicade ao elemento que segura criado anteriormente
      $textoNoticia.find('.texto-noticia-pub').append($pubAppend);
    }
  }
});

/* =================== FOTOS DETALHE =================== */
$(function () {
  $('.carrosel-fotos').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

/* =================== CARROSSEL RELACIONADOS =================== */
$(function () {
  $('.carrosel-materias').slick({
    slidesToShow: 4,
    slidesToScroll: 5,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 760,
        settings: 'unslick',
      },
    ],
  });
});
